/* src/app/modules/comissions/components/list-votes/list-votes.component.scss */
/*# sourceMappingURL=list-votes.component.css.map */
